export default "__VITE_ASSET__Miqlv0pt__"